module.exports = __webpack_public_path__ + "img/jeans1.b34a7088.jpg";